import { render, staticRenderFns } from "./UpdateSiteAddress.vue?vue&type=template&id=658491b1&"
import script from "./UpdateSiteAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateSiteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateSiteAddress.vue"
export default component.exports